import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90vh;
  height: 90vh;
  background-color: #fafafa;
`;

export const Title = styled.h1`
  padding: 2rem;
  font-size: 3rem;
`;

export const Description = styled.div`
  padding: 3rem;
  font-size: 1.5rem;
`;
